import { FiTarget } from 'react-icons/fi';
import { GoLocation } from 'react-icons/go';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Header: any = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: row;
`;
Header.Title = styled.h4`
  font-size: 14px;
  line-height: 1.2em;
  font-weight: 600;
  color: ${ColorPalette.HEX.PineTree};
  margin: 0 0 10px;
`;
Header.Selected = styled.div`
  color: ${ColorPalette.HEX.White};
  transition: 0.3s;
  line-height: normal;
  font-weight: 500;
  border-radius: 10px;
  cursor: pointer;
  font-size: 12px;
  height: 20px;
  background: ${({ theme }) => theme.button.background};
  padding: 1px 10px;
`;

export const Info = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: row;
`;
export const Address: any = styled.ul`
  flex: 2;
  font-size: 12px;
  color: ${ColorPalette.HEX.DimGray2};
  padding: 0;
  list-style: none;
`;

Address.Item = styled.li`
  display: flex;
  line-height: 1.4em;
  align-items: flex-start;
  margin-bottom: 2px;
  & strong {
    font-weight: 600;
    color: ${ColorPalette.HEX.PineTree};
  }
`;

Address.Icon = styled.span`
  width: 12px;
  height: 12px;

  margin-right: 2px;
`;

Address.Price = styled.div`
  flex: 1;
  text-align: right;
  & strong {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: ${ColorPalette.HEX.PineTree};
  }
`;

Address.Period = styled.span`
  font-size: 10px;
  color: ${ColorPalette.HEX.DimGray2};
`;

export const IconPickUp = styled(FiTarget)`
  width: 12px;
  height: 12px;
  color: ${ColorPalette.HEX.PineTree};
`;

export const IconDropOff = styled(GoLocation)`
  width: 12px;
  height: 12px;
  color: ${ColorPalette.HEX.PineTree};
`;
